// modules/reports/InKindServicesReport.jsx
import InKindBaseReport from "./InKindBaseReport";

const InKindServicesReport = () => {
  return (
    <InKindBaseReport
      title="In-Kind Services"
      description="Match service donations with needs and track in-kind contributions"
      type="services"
      categoryEndpoint="servicetypes"
      categoryLabel="Service Type"
      resourceName="admin/in-kind-services"
      statisticsEndpoint="admin/in-kind-services/statistics"
    />
  );
};

export default InKindServicesReport;